/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('modules/Delivery/PriceAndDeliveryOptions',[
    'jquery',
    'lodash',
    'global/all',
    'global/Geolocation',
    'modules/InStorePickup/InStorePickup',
    'modules/Product/ProductService',
    'modules/Store/StoreLocationService',
    'modules/User/Users',
    'modules/Delivery/PriceAndDeliveryOptions.Forms',
    'modules/Delivery/PriceAndDeliveryOptionsService', 
    'modules/Delivery/TotalQuantityAndPrice', 
    'plugins/accounting.min',
    'plugins/jquery.matchHeight'
], function ($, _, Roc, Geolocation, InStorePickup, ProductService, StoreLocationService, Users, PriceAndDeliveryForms, PriceAndDeliveryOptionsService, TotalQuantityAndPrice, accounting) {
    'use strict';

    var forms = PriceAndDeliveryForms;
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var signInUrl;
    var countries;
    var addressBookUrl;
    var deliveryOptions;
    var isProductDetailsPage;
    var currentOrderItemId;
    var currentShipToAddress;
    var selectedStoreId = null;
    var showHideAddToCartButtonCallback;
    var isBusinessAccount;

    function getDeliveryContainer(src) {
        return $(src).closest('.delivery-option-list');
    }

    function getProductIdFromContainer($deliveryContainer) {
        return $deliveryContainer.attr('data-roc-productId');
    }

    function getOrderItemIdFromContainerAttr($deliveryContainer) {
        return $deliveryContainer.attr('data-roc-order-item-id');
    }

    function getSelectedAddressBookIdFromContainer($deliveryContainer) {
        var $hdn = $deliveryContainer.find('input.hdnDeliveryAddressId');
        if ($hdn.length === 1 && $hdn.val() !== Roc.Enums.general.DEFAULT_GUID) {
            return $hdn.val();
        }
        return null;
    }

    function getDeliveryContainerFromModal(element) {
        var $modalContainer = $(element).closest('div.white-popup');
        var productId = $modalContainer.attr('data-roc-productId');
        var orderItemId = $modalContainer.attr('data-roc-order-item-id');
        var itemQty = parseInt($modalContainer.attr('data-roc-quantity'));
        return {
            productId: productId,
            orderItemId: orderItemId,
            itemQty: itemQty,
            $modal: $modalContainer,
            $container: $('.delivery-option-list[data-roc-productId="' + productId + '"][data-roc-order-item-id="' + orderItemId + '"]')
        };
    }

    function getAddRecipientForm($modal) {
        var tmpForm = $.extend(true, {}, forms.addRecipient);

        _.forEach(tmpForm.Fields, function (field) {
            field.Field = '#' + $modal.attr('id') + " " + field.Field;
            if (field.hasOwnProperty("Validators")) {
                _.forEach(field.Validators, function (validator) {
                    if (validator.hasOwnProperty("ConditionalField")) {
                        validator.ConditionalField = '#' + $modal.attr('id') + " " + validator.ConditionalField;
                    }
                    if (validator.hasOwnProperty("ReferencedField")) {
                        validator.ReferencedField = '#' + $modal.attr('id') + " " + validator.ReferencedField;
                    }
                });
            }
        });

        return tmpForm;
    }

    function canBeOrdered(options) {
        var pickupStatus = "Unavailable";

        if (options.inventoryAvailability.pickupDetails) {
            pickupStatus = options.inventoryAvailability.pickupDetails.inventorySummary.status;
        }

        var shippingStatus = options.inventoryAvailability.shippingSummary.status;

        return (pickupStatus === "Available" ||
            pickupStatus === "Backorder" ||
            shippingStatus === "Available" ||
            shippingStatus === "Backorder");
    }

    function validateAddRecipientForm($modal) {
        var form = getAddRecipientForm($modal);
        return Roc.Validation.validateForm(form);
    }

    function updateRecipient($deliveryContainer, recipientData) {
        if (recipientData) {
            $deliveryContainer.find('.hdnAddRecipientFirstName').val(recipientData.firstName);
            $deliveryContainer.find('.hdnAddRecipientLastName').val(recipientData.lastName);
            $deliveryContainer.find('.hdnAddRecipientZip').val(recipientData.zip);
            $deliveryContainer.find('.hdnAddRecipientCity').val(recipientData.city);
            $deliveryContainer.find('.hdnAddRecipientCountry').val(recipientData.country);
            $deliveryContainer.find('.hdnAddRecipientState').val(recipientData.state);
        } else {
            $deliveryContainer.find('input[class^="hdnAddRecipient"]').val('');
        }
    }

    function clearAddRecipientForm($deliveryContainer) {
        var form = getAddRecipientForm($deliveryContainer);

        _.forEach(form.Fields, function (f) {
            $(f.Field).val('');
        });

        Roc.UI.clearFormErrors(form);
        updateRecipient($deliveryContainer);
    }

    function updateDeliveryType($deliveryContainer, deliveryType, notify) {
        var orderItemId = getOrderItemIdFromContainerAttr($deliveryContainer);
        $deliveryContainer.find('input[name="delivery-type-' + orderItemId + '"]').attr('checked', false);
        $deliveryContainer.find('input[name="delivery-type-' + orderItemId + '"][value="' + deliveryType + '"]').prop('checked', true);
        $deliveryContainer.find('.hdnDeliveryType').val(deliveryType);
        if (notify) {
            var productId = getProductIdFromContainer($deliveryContainer);
            Roc.EventManager.notify(Roc.Events.delivery.DELIVERY_OPTION_CHANGED, {
                'productId': productId,
                'orderItemId': orderItemId,
                'deliveryType': deliveryType
            });
        }
    }

    function displayRecipientSummary($deliveryContainer, summary) {
        $deliveryContainer.find('.delivery-option span.recipient-summary').text(summary);
    }

    function deliveryOptionEvt() {
        Roc.UI.siteBody
            .off('click', 'input[type="radio"][name^="delivery-type"]')
            .on('click', 'input[type="radio"][name^="delivery-type"]', function () {
                Roc.UI.Modal.close();
                var deliveryType = $(this).val();
                var $deliveryContainer = getDeliveryContainer(this);
                updateDeliveryType($deliveryContainer, deliveryType, true);
            });
    }

    function deliveryModalOpenedEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="openDeliveryModal"]')
            .on('click', '[data-roc-action="openDeliveryModal"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                var itemId = getOrderItemIdFromContainerAttr($deliveryContainer);
                var selectedAddressId = getSelectedAddressBookIdFromContainer($deliveryContainer);
                if (selectedAddressId) {
                    clearAddRecipientForm($deliveryContainer);
                    $deliveryContainer.find('input[name="delivery-shipping"][value="' + selectedAddressId + '"]').prop('checked', true);
                } else {
                    $deliveryContainer.find('input.delivery-first-name').val($deliveryContainer.find('.hdnAddRecipientFirstName').val());
                    $deliveryContainer.find('input.delivery-last-name').val($deliveryContainer.find('.hdnAddRecipientLastName').val());
                    $deliveryContainer.find('input.delivery-zip').val($deliveryContainer.find('.hdnAddRecipientZip').val());
                    $deliveryContainer.find('input.delivery-city').val($deliveryContainer.find('.hdnAddRecipientCity').val());
                    $deliveryContainer.find('input.delivery-state').val($deliveryContainer.find('.hdnAddRecipientState').val());
                    $deliveryContainer.find('input[name="delivery-shipping"]').prop('checked', false);
                }
                Roc.UI.Modal.open('#delivery-ship-' + itemId);
                bindCountryChangeEvt();
                bindZipCodeLookUpEvt();
            });
    }

    function bindCountryChangeEvt() {
        var selector = '#delivery-country';
        var eventNameWithNamespace = 'change.deliveryOptions-bindCountryChangeEvt';
        $(document)
            .off(eventNameWithNamespace, selector)
            .on(eventNameWithNamespace, selector, function () {
                bindZipCodeLookUpEvt();
            });
    }

    function bindZipCodeLookUpEvt() {
        if (window.RocConfig.google.enableAddressAutocomplete === true) {
            // bind zip code lookup plugin
            var countryCode = $('#delivery-country').val() || window.RocConfig.defaultCountryCode;
            Roc.UI.ziplookup('input.delivery-zip', {
                country: countryCode,
                fieldsMapping: {
                    "CITY": 'input.delivery-city',
                    "STATE_OR_REGION": 'input.delivery-state'
                }
            });
        }
    }

    function deliveryFormFocusedEvt() {
        Roc.UI.siteBody
            .off('focus', '.recipient-form input[type="text"]')
            .on('focus', '.recipient-form input[type="text"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                $deliveryContainer.find('input[name="delivery-shipping"]').attr("checked", false);
            });
    }

    function signInEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="signInToSeeAddresses"]')
            .on('click', '[data-roc-action="signInToSeeAddresses"]', function () {
                window.location.href = signInUrl;
                Roc.Core.lockButton('[data-roc-action="signInToSeeAddresses"]');
            });
    }

    function addressBookSelectedEvt() {
        Roc.UI.siteBody
            .off('click', 'input[name="delivery-shipping"]')
            .on('click', 'input[name="delivery-shipping"]', function () {
                var addressBookId = $(this).val();
                var result = getDeliveryContainerFromModal(this);
                var alreadySelectedAddress = getSelectedAddressBookIdFromContainer(result.$container);
                if (addressBookId !== alreadySelectedAddress) {
                    updateDeliveryType(result.$container, 'Shipping', false);
                    clearAddRecipientForm(result.$container);
                    var summary = $(this).attr('data-recipient-summary');
                    displayRecipientSummary(result.$container, summary);
                    result.$container.find('.hdnDeliveryAddressId').val(addressBookId);
                    result.$container.find('.hdnAddRecipientFirstName').val('');
                    result.$container.find('.hdnAddRecipientLastName').val('');
                    result.$container.find('.hdnAddRecipientZip').val('');
                    result.$container.find('.hdnAddRecipientCity').val('');
                    result.$container.find('.hdnAddRecipientCountry').val('');
                    result.$container.find('.hdnAddRecipientState').val('');
                    Roc.EventManager.notify(Roc.Events.delivery.ADDRESS_BOOK_SELECTED, {
                        'productId': result.productId,
                        'orderItemId': result.orderItemId,
                        'addressBookId': addressBookId
                    });
                    Roc.UI.Modal.close();
                }
            });
    }

    function submitDeliveryFormEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="submitDeliveryForm"]')
            .on('click', '[data-roc-action="submitDeliveryForm"]', function () {
                var result = getDeliveryContainerFromModal(this);
                if (validateAddRecipientForm(result.$modal)) {
                    var recipientData = Roc.Forms.getFormValues(forms.addRecipient, result.$modal);
                    updateDeliveryType(result.$container, 'Shipping', false);
                    updateRecipient(result.$container, recipientData);

                    displayRecipientSummary(result.$container, Roc.UI.formatRecipientLabel(recipientData));
                    result.$container.find('.hdnDeliveryAddressId').val('');

                    Roc.EventManager.notify(Roc.Events.delivery.RECIPIENT_DATA_PROVIDED, {
                        'productId': result.productId,
                        'orderItemId': result.orderItemId,
                        'address': recipientData
                    });

                    Roc.UI.Modal.close();
                }
            });
    }

    function cancelDeliveryForm() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="cancelDeliveryForm"]')
            .on('click', '[data-roc-action="cancelDeliveryForm"]', function () {
                Roc.UI.Modal.close();
            });
    }

    function findStoreEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="findAnotherStore"]')
            .on('click', '[data-roc-action="findAnotherStore"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                var productId = getProductIdFromContainer($deliveryContainer);
                ProductService.getById(productId).then(function (product) {
                    InStorePickup.findPickupStore(product)
                        .then(function (selectedStore) {
                            selectedStoreId = selectedStore.location.id;
                            deliveryOptions.selectedDeliveryType = 'Pickup';
                            deliveryOptions.inventoryAvailability.pickupDetails = selectedStore;
                            render(deliveryOptions);
                        });
                }, function () {
                    Roc.UI.displayErrorPopup('There was an error while trying to get warehouses.');
                });
            });
    }

    function prepareViewModel(data) {
        if (data) {
            // extend provided view model with necessary data for template rendering
            $.extend(data, {
                signInUrl: signInUrl,
                countries: countries,
                addressBookUrl: addressBookUrl,
                isProductDetailsPage: isProductDetailsPage,
                isBusinessAccount: isBusinessAccount,
                defaultCountryCode: window.RocConfig.defaultCountryCode,
                enableInternationalShipping: window.RocConfig.shipping.enableInternationalShipping
            });

            // if user already selected address book or provided address
            // then overwrite "Ship To" data from the api response
            var $deliveryOptions = $('#delivery-options');
            var $addressIdField = $deliveryOptions.find('.hdnDeliveryAddressId');
            if ($addressIdField.length === 1) {
                var addressBookId = $addressIdField.val();
                if (addressBookId !== '') {
                    var selectedAddressBook = _.find(data.addresses, {
                        'id': addressBookId
                    });
                    if (selectedAddressBook) {
                        currentShipToAddress = selectedAddressBook;
                    }
                } else {
                    currentShipToAddress = {
                        'firstName': $deliveryOptions.find('.hdnAddRecipientFirstName').val(),
                        'lastName': $deliveryOptions.find('.hdnAddRecipientLastName').val(),
                        'zip': $deliveryOptions.find('.hdnAddRecipientZip').val(),
                        'city': $deliveryOptions.find('.hdnAddRecipientCity').val(),
                        'country': $deliveryOptions.find('.hdnAddRecipientCountry').val(),
                        'state': $deliveryOptions.find('.hdnAddrecipientState').val()
                    };
                }
            }

            if (currentShipToAddress) {
                data.shipToAddress = currentShipToAddress;
            }
            return data;
        }
        return null;
    }

    function isAnyDeliveryOptionAvailable() {
        if (deliveryOptions) {
            return deliveryOptions.multiShipToEnabled || deliveryOptions.inStorePickupEnabled;
        }
        return false;
    }

    function isAllDeliveryOptionAvailable() {
        if (deliveryOptions) {
            return deliveryOptions.shippingEnabled && deliveryOptions.inStorePickupEnabled;
        }
        return false;
    }

    function verifyAddToCartButtonVisibility() {
        if (typeof showHideAddToCartButtonCallback === 'function') {
            if (isAnyDeliveryOptionAvailable()) { // if there is at least one delivery option available then show/hide add to cart button
                if (deliveryOptions.selectedDeliveryType === 'Virtual' || deliveryOptions.productType === 'Group') {
                    showHideAddToCartButtonCallback(true);
                    return;
                }
                var shippingAvailable = false;
                var pickupAvailable = false;
                var inventory = deliveryOptions.inventoryAvailability;
                if (inventory) {
                    var unavailableStatuses = ['Unavailable', 'OutOfStock'];
                    shippingAvailable = unavailableStatuses.indexOf(inventory.shippingSummary.status) === -1;
                    pickupAvailable = deliveryOptions.inStorePickupEnabled && inventory.pickupDetails !== null && unavailableStatuses.indexOf(inventory.pickupDetails.inventorySummary.status) === -1;
                }
                showHideAddToCartButtonCallback(shippingAvailable || pickupAvailable);
            }
        }
    }

    function verifyChangeDeliveryButtonVisibility(container) {
        if (isAllDeliveryOptionAvailable()) {
            var changeDelivevyButton = $(container).closest('.itemWrapper').find($('[data-roc-modal="#delivery-options-popup-' + deliveryOptions.orderItemId + '"]'));
            if (changeDelivevyButton && changeDelivevyButton.length > 0) {
                changeDelivevyButton.removeClass('hidden');
            }
        }
    }

    function verifyNonAvailableWarning(container, data) {
        if (data.selectedDeliveryType === 'Pickup'
            && data.inventoryAvailability.pickupDetails
            && data.inventoryAvailability.pickupDetails.inventorySummary
            && data.inventoryAvailability.pickupDetails.inventorySummary.availableQuantity < data.quantityInCart) {
            $('.availability-warning[data-roc-availability-warning="' + data.orderItemId + '"]').removeClass('hidden');
        } else {
            $('.availability-warning[data-roc-availability-warning="' + data.orderItemId + '"]').addClass('hidden');
        }
    }

    function render(data, container) {
        if (!data || container.length === 0) {
            return null;
        }

        deliveryOptions = prepareViewModel(data);
        verifyAddToCartButtonVisibility();
        verifyChangeDeliveryButtonVisibility(container);
        verifyNonAvailableWarning(container, data);
        Roc.UI.renderFormTemplate('deliveryOptions-Tmp', deliveryOptions, $(container)).then(function () {
            var $deliveryOptions = $('.itemWrapper .delivery-options');
            $deliveryOptions.css('min-height', '0');
            equalheight($deliveryOptions);
            clickAvaiableinRegionEvt();
        });
    }

    function getDeliveryOptionsFromContainer($deliveryContainer) {
        var deliveryType = $deliveryContainer.find('input.hdnDeliveryType').val();

        return getDeliveryMethodDependingOnType(deliveryType, $deliveryContainer);
    }

    function getDeliveryMethodDependingOnType(deliveryType, $deliveryContainer) {
        var deliveryOptions = {
            'addressBookId': null,
            'pickupLocationId': null,
            'address': null,
            'deliveryType': deliveryType
        };

        switch (deliveryType) {
        case 'Shipping':
            var selectedAddress = getSelectedAddressBookIdFromContainer($deliveryContainer);
            if (selectedAddress) {
                deliveryOptions.addressBookId = selectedAddress;
            } else {
                var country = $deliveryContainer.find('.hdnAddRecipientCountry').val();
                if (country) {
                    deliveryOptions.address = {
                        'firstName': $deliveryContainer.find('.hdnAddRecipientFirstName').val(),
                        'lastName': $deliveryContainer.find('.hdnAddRecipientLastName').val(),
                        'zip': $deliveryContainer.find('.hdnAddRecipientZip').val(),
                        'city': $deliveryContainer.find('.hdnAddRecipientCity').val(),
                        'country': $deliveryContainer.find('.hdnAddRecipientCountry').val(),
                        'state': $deliveryContainer.find('.hdnAddRecipientState').val()
                    }
                }
            }
            break;
        case 'Pickup':
            deliveryOptions.pickupLocationId = $deliveryContainer.find('.hdnPickupId').val();
            break;
        }
        return deliveryOptions;
    }

    function updateProductAvailability(options) {
        var container = getProductDeliveryOptionsContainer(options.productId, options.orderItemId, options.sku).parent();

        if (canBeOrdered(options)) {
            render(options, container); 
        } else {
            render(null, container);
        }
    }

    function updateProductPricing(options) {
        if (options.sku === "CUSTOM") {
            return;
        }
        var priceSelector = '.itemPrice[data-product-id=' + options.productId + '] > div.currentPrice > strong.price';
        var uomNameSelector = '.itemPrice[data-product-id=' + options.productId + '] > div.currentPrice > strong.unitOfMeasureLabel';
       var uomSelector = '.selectedUom[data-roc-productId=' + options.productId + ']';
        reloadPrice(options, priceSelector, uomSelector,uomNameSelector);
        showPrice(priceSelector, uomNameSelector);
    }

    function showAddToCartButton() {
        if ($('#addToCartBtn').length > 0) {
            $('#addToCartBtn').show();
        }
    }

    function showWarning() {
        if ($('#addToCartBtn').length > 0) {
            $('#boxWarning').html("<div class='avaibilityWarning'>This product is currently not available online. Please contact us if you would like to order<div>");
        }
    }

    function loadDeliveryOptionsForMultipleProducts(productSkus) {
        productSkus = _.filter(productSkus, function(item) { return item !== null });
        PriceAndDeliveryOptionsService.getDeliveryOptionsForMultipleProducts(productSkus).then(updateMultipleDeliveryOptions, $.noop);
    }

    function loadDeliveryOptionsForCart() {
        Roc.UI.block('.delivery-option-list');
        PriceAndDeliveryOptionsService.getDeliveryOptionsForCart()
            .then(updateMultipleDeliveryOptions, function () { Roc.UI.unblock('.delivery-option-list'); });
    }

    function updateMultipleDeliveryOptions(multipleOptions) {
        $.each(multipleOptions,
            function (i, options) {
                updateProductAvailability(options);
                updateProductPricing(options);
            });
        Roc.UI.unblock();
    }

    function getProductDeliveryOptionsContainer(productId, orderItemId, productSku) {
        var container;
        if (orderItemId) {
            container = $('.delivery-option-list[data-roc-productid="' + productId + '"][data-roc-order-item-id="' + orderItemId + '"]');
        } else if (productSku) {
            container = $('.delivery-option-list[data-roc-sku="' + productSku + '"]');
        } else {
            container = $('.delivery-option-list[data-roc-productid="' + productId + '"]');
        }
        return container;
    }

    function getProductDeliveryOptions(productId, orderItemId) {
        var $deliveryContainer = getProductDeliveryOptionsContainer(productId, orderItemId);
        if ($deliveryContainer.length === 0) {
            return null;
        }
        return getDeliveryOptionsFromContainer($deliveryContainer);
    }

    function getAllProductDeliveryOptionsByType(productId, orderItemId, deliveryType) {
        var $deliveryContainer = getProductDeliveryOptionsContainer(productId, orderItemId);
        if ($deliveryContainer.length === 0) {
            return null;
        }
        return getDeliveryMethodDependingOnType(deliveryType, $deliveryContainer);
    }

    function reloadDeliveryOptions(productViewModel) {
        if (productViewModel) {
            fetchDeliveryOptions(productViewModel.id);
        } else {
            render(null);
        }
    }

    function reloadDeliveryOptionsForDetailsPage() {
        var deliveryOptions = $('.delivery-option-list').first();
        Roc.UI.block('.delivery-option-list');
        var productId = deliveryOptions.attr("data-roc-productid");
        fetchDeliveryOptions(productId);
    }

    function reloadDeliveryOptionsForListingPage() {
        Roc.UI.block();
        var skus = [];
        $.each($('.productAddToCartContainer'), function (index, element) {
            skus.push($(element).attr('data-roc-sku'));
        });
        loadDeliveryOptionsForMultipleProducts(skus);
    }

    function reloadPrice(option, priceSelector, uomSelector, uomNameSelector) {
        if (option) {
            $('#boxWarning').empty();
            var price = $(priceSelector);
            var uomDivider = 1;
            if (option.price) {
                if (price.length > 0) {  
                    var uom = $(uomSelector);
                    if (option.unitOfMeasure) {
                        uom.val(option.unitOfMeasure.id);

                        if (uomNameSelector) {
                            var uomName = $(uomNameSelector);
                            uomName.html(option.unitOfMeasure.isBaseUnit ? '' : ' (' + option.unitOfMeasure.name + ')');
                        }
                        
                    } else {
                        uom.val('');
                    }
                    var priceText = accounting.formatMoney((option.price));
                    price.text(priceText);
                }
                TotalQuantityAndPrice.handleQuantityChange(option.productId);
                showAddToCartButton();
            } else if (option.price === 0) {
                if (price.length > 0) {
                    price.text("");
                    showWarning();
                }
            } else {
                showAddToCartButton();
            }
        }
    }

    function showPrice(priceSelector, uomNameSelector) {
        var price = $(priceSelector);
        price.show(); 
        if (uomNameSelector) {
            var uom = $(uomNameSelector);
            uom.show();
        }
    }

    function fetchDeliveryOptions(productId) {
        var priceSelector = 'div.itemPrice > div > div.currentPrice > strong.price';
        var uomNameSelector = 'div.itemPrice > div > div.currentPrice > strong.unitOfMeasureLabel';
        var uomSelector = '.selectedUom[data-roc-productId=' + productId + ']';
        var unitOfMeasure = $(uomSelector).val();

        PriceAndDeliveryOptionsService.getDeliveryOptionsForSingleItem(productId, currentOrderItemId, unitOfMeasure)
            .then(function (options) {
                if (options.productType !== "Group") {
                    render(options, $('#delivery-options'));
                    reloadPrice(options, priceSelector, uomSelector, uomNameSelector);
                    showPrice(priceSelector, uomNameSelector);
                }
            }, function () {
                render(null, $('#delivery-options'));
                showPrice(priceSelector);
            });
    }

    function loadWarehousesInRegion(response) { 
        Roc.UI.template('warehousesInRegion-Tmp', { locations: response.responseJSON }).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
        });
    }

    function clickAvaiableinRegionEvt() {
        $('#availableInRegionLink')
            .off('click')
            .on('click', function () {
                PriceAndDeliveryOptionsService.getWarehousesInRegion(loadWarehousesInRegion);
            });
    }

    function bindEvents() {
        deliveryOptionEvt();
        deliveryModalOpenedEvt();
        signInEvt();
        deliveryFormFocusedEvt();
        addressBookSelectedEvt();
        submitDeliveryFormEvt();
        cancelDeliveryForm();
        findStoreEvt();
        clickAvaiableinRegionEvt();
    }

    function bindProductDetailsEvents() {
        bindEvents();
    }

    function bindCartPageEvents() {
        bindEvents();
        Roc.EventManager.bind(Roc.Events.cart.RENDERED, loadDeliveryOptionsForCart);
    }

    function bindListingPageEvents() {
        bindEvents();
    }

    function baseInit(options) {
        signInUrl = options.signInUrl;
        addressBookUrl = options.addressBookUrl;
        countries = options.countries;
    }

    function initProductDetailsPage(options) { 
        isProductDetailsPage = true;
        isBusinessAccount = options.isBusinessAccount;
        currentOrderItemId = options.currentOrderItemId;
        baseInit(options);
        bindProductDetailsEvents();
        // Load delivery options from service
        fetchDeliveryOptions(options.productId);
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadDeliveryOptions);
    }

    function initCartPage(options) { 
        baseInit(options);
        isBusinessAccount = options.isBusinessAccount;
        bindCartPageEvents();
    };

    function initListingPage(options) { 
        baseInit(options);
        isBusinessAccount = options.isBusinessAccount;
        bindListingPageEvents();
    };

    function setAddToCartButtonVisibilityCallback(callback) {
        showHideAddToCartButtonCallback = callback;
    }

    function reloadPriceAfterSelection(product) {  
        fetchDeliveryOptions(product.id);
    }

    var PriceAndDeliveryOptions = {
        initCartPage: initCartPage,
        initListingPage: initListingPage,
        initProductDetailsPage: initProductDetailsPage,
        getProductDeliveryOptions: getProductDeliveryOptions,
        getProductDeliveryOptionsByType: getAllProductDeliveryOptionsByType,
        isAnyDeliveryOptionAvailable: isAnyDeliveryOptionAvailable,
        setAddToCartButtonVisibilityCallback: setAddToCartButtonVisibilityCallback,
        loadDeliveryOptions: loadDeliveryOptionsForMultipleProducts,
        reloadPriceAfterSelection: reloadPriceAfterSelection
    };

    Roc.Logger.debug('PriceAndDeliveryOptions.js Loaded:', PriceAndDeliveryOptions);

    return PriceAndDeliveryOptions;

});
